// extracted by mini-css-extract-plugin
export default {"homePageContainer":"HomePage_homePageContainer__TbjDn","searchInput":"HomePage_searchInput__BPaB4","form":"HomePage_form__S9Tra"};